import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Close from "material-ui/svg-icons/navigation/close";

const defaultProps = {
  text: '',
};

function ConfirmDialog(props) {
  const actions = [
    <FlatButton label="Cancel" primary onTouchTap={props.onCancel} />,
    <FlatButton label="Confirm" primary keyboardFocused onTouchTap={props.onConfirm} />,
  ];

  const close = [<Close style={{ float: 'right' }} onTouchTap={props.onCancel} />];

  const title = props.closeWithoutSave ?
    (
      <div className="row">
        <div className="col-xs-11">
          <p>{props.title}</p>
        </div>
        <div className="col-xs-1" style={{ float: "right"}}>
          {close[0]}
        </div>
      </div>
    ) :
    null;

  return (
    <Dialog
      className={props.className ? props.className : ''}
      title={props.title ? title : "Please confirm"}
      // actions={actions}
      actions={props.closeWithoutSave ? false : actions}
      modal={false}
      open={props.open}
    >
      {props.text}
    </Dialog>
  );
}

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog.js